/// <amd-module name="Wit/LinkedWorkItemsDropdown/Components/LinkedWorkItemsShelvesetDetails" />
import * as React from "react";
import { onClickFPS } from "VSS/Platform/FPS";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Card } from "VSSUI/Card";
import { ReadyableArrayObserver } from "VSSUI/Observer";
import { ITableRow } from "VSSUI/Table";
import * as Resources from "Wit/LinkedWorkItemsDropdown/Resources";
import { getLinkedWorkItemsShelvesetDetailViewService } from "../LinkedWorkItemsShelvesetDetailViewService";
import { IWorkItemEntry } from "../Util/Data";
import { LinkedWorkItemsTable } from "./LinkedWorkItemsTable";

interface ILinkedWorkItemsShelvesetDetailsProps {
    shelvesetName: string;
}

export class LinkedWorkItemsShelvesetDetails extends VssComponent<ILinkedWorkItemsShelvesetDetailsProps> {
    public render() {
        const viewService = getLinkedWorkItemsShelvesetDetailViewService(this.context.pageContext);

        return (
            <div className="flex-column rhythm-vertical-8">
                <ReadyableArrayObserver
                    data={viewService.getLinkedWorkItems("", "", this.props.shelvesetName)}
                    dataComponent={this.renderDataComponent}
                />
            </div>
        );
    }

    private renderDataComponent = () => {
        const viewService = getLinkedWorkItemsShelvesetDetailViewService(this.context.pageContext);

        return (
            <Card className="bolt-table-card" titleProps={{ text: Resources.WorkItems }}>
                <LinkedWorkItemsTable
                    expanded={true}
                    itemProvider={viewService.getLinkedWorkItems("", "", this.props.shelvesetName)}
                    onActivate={(event: React.SyntheticEvent<HTMLElement>, tableRow: ITableRow<IWorkItemEntry>) => {
                        if (!event.defaultPrevented) {
                            onClickFPS(this.context.pageContext, tableRow.data.href!, true, event);
                        }
                    }}
                />
            </Card>
        );
    };
}
Components.add("WIT.LinkedWorkItemsShelvesetDetails", LinkedWorkItemsShelvesetDetails);
